import { CurrentUser, GetUserData } from "common/service/CommonService";
import { APIClient } from "../../../../api/api_helper";
import { AMBULATORY_VISIT_ACTIVITY_RESULT_API, AMBULATORY_VISIT_API } from "../../../../api/url_helper";
import { DROPOUT_TYPE_OPTIONS } from "api/modules/common.option";

const api = new APIClient();

export const ambulatoryVisitApiService = {

  selectallAmbulatoryVisit: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_API + "SelectAll", data);
  },

  selectdataAmbulatoryVisit: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_API + "Select", data);
  },

  assignSubjects: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_SUBJECT_ASSIGNMENT_API + "Insert", data);
  },

  selectAllAssignedSubjects: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_SUBJECT_ASSIGNMENT_API + "SelectAll", data);
  },

  insertAmbulatoryVisitStatusHistory: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_STATUS_HISTORY_API + "Insert", data);
  },

  checkInSubject: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_SUBJECT + "CheckIn", data);
  },

  checkOutSubject: (data: any) => {
    return api.create(AMBULATORY_VISIT_API.AMBULATORY_VISIT_SUBJECT + "CheckOut", data);
  },

  insertSubjectActivityResult: (payload: any) => {
    const { subject, formValues, activityAttachments, comments, studyid, subjectId } = payload;
    const formData = new FormData();
    const userData = GetUserData() as CurrentUser;
    const visitsubjectassignmentid = Number(subject.visitsubjectassignmentid || subject.id || 0);
    const createdby = Number(userData?.userid || 1);

    formData.append("visitsubjectassignmentid", String(visitsubjectassignmentid));
    formData.append("createdby", String(createdby));

    // activityresultlist JSON payload
    const activityresultlist = (subject.activities || []).map((act: any) => ({
      visitactivityid: Number(act.id),
      subjectactivityresult: act.result,
      remarks: act.remarks || ""
    }));
    formData.append("activityresultlist", JSON.stringify(activityresultlist));

    // files and file mapping
    const attachmentfiles: { visitactivityid: number; filename: string }[] = [];
    const deletedAttachmentIds: number[] = [];

    Object.entries(activityAttachments).forEach(([activityId, atts]: [string, any]) => {
      if (atts.uploadedFiles) {
        atts.uploadedFiles.forEach((file: File) => {
          (file as any).visitactivityid = Number(activityId);
          formData.append(`files[${activityId}]`, file);
        });
      }
      if (atts.deletedAttachmentIds) {
        deletedAttachmentIds.push(...atts.deletedAttachmentIds);
      }
    });

    formData.append("attachments", JSON.stringify(attachmentfiles));
    formData.append("deletedattachmentids", JSON.stringify(deletedAttachmentIds));
    formData.append("deletedAttachmentIds", JSON.stringify(deletedAttachmentIds));

    // decision status and remarks
    const statusVal = formValues.status;
    formData.append("decisionstatus", statusVal || "");
    formData.append("decisionremarks", comments || "");

    // decision details JSON
    let decisiondetails: any = [];
    const volunteerid = Number(subject.volunteerid || subject.volunteerId || 0);
    const subjectno = subject.subjectno || subject.subjectId || subjectId;
    const currentStatus = formValues.status?.toLowerCase();

    if (currentStatus === "dropped") {
      const selectedType = DROPOUT_TYPE_OPTIONS.find(
        (opt) => String(opt.value) === String(formValues.dropouttype) || opt.label === formValues.dropouttype
      )?.label || (formValues.dropouttype ? String(formValues.dropouttype) : null);
      const isAE = selectedType === "Medical / AE";

      decisiondetails = [{
        volunteerid,
        studyid,
        subjectno,
        dropouttype: formValues.dropouttype,
        dropoutdate: formValues.dropoutdate,
        studystage: formValues.studystage,
        effectivedate: formValues.effectivedate,
        dropoutreason: formValues.dropoutreason,
        detailedreason: formValues.detailedreason,
        ...(isAE ? { aereferenceno: formValues.aereferenceno } : {})
      }];
    } else if (currentStatus === "blocked") {
      const isPermanent = formValues.blocktype === "Permanent";
      decisiondetails = [{
        volunteerid,
        studyid,
        subjectno,
        blocktype: formValues.blocktype,
        blockreason: formValues.blockreason,
        blocksource: "ambulatory-visit",
        startdate: formValues.blockstartdate,
        remarks: formValues.detailedremarks || comments || "",
        ...(isPermanent ? {} : {
          enddate: formValues.blockenddate,
          blockduration: formValues.blockduration,
          rescreeningeligibility: formValues.rescreeningeligibility
        })
      }];
    }
    formData.append("decisiondetails", JSON.stringify(decisiondetails));

    return api.create(AMBULATORY_VISIT_ACTIVITY_RESULT_API.AMBULATORY_VISIT_ACTIVITY_RESULT_API + "Insert", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  selectdataAmbulatoryVisitActivityResult: (data: any) => {
    return api.create(AMBULATORY_VISIT_ACTIVITY_RESULT_API.AMBULATORY_VISIT_ACTIVITY_RESULT_API + "Select", data);
  },
};
